module.exports = __webpack_public_path__ + "img/avatar4.f0994d7c.png";